import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  overview: () => client.get("/overview").then((r) => r.data),
  students: () => client.get("/students").then((r) => r.data),
  student: (id) => client.get(`/students/${id}`).then((r) => r.data),
  createStudent: (data) => client.post("/students", data).then((r) => r.data),
  updateStudent: (id, data) => client.put(`/students/${id}`, data).then((r) => r.data),
  setStage: (id, stage) => client.post(`/students/${id}/stage`, { stage }).then((r) => r.data),
  addIntervention: (id, data) => client.post(`/students/${id}/interventions`, data).then((r) => r.data),
  parentMessage: (id) => client.post(`/students/${id}/parent-message`).then((r) => r.data),
  interventions: () => client.get("/interventions").then((r) => r.data),
  insights: () => client.get("/insights").then((r) => r.data),
};
